module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-2800.6fd3fa95.svg";